// extracted by mini-css-extract-plugin
export default {"surface":"plain-popup-id-to-clipboard_surface__x3GyL","title":"plain-popup-id-to-clipboard_title__cOLBn","placeHolderShimmer":"plain-popup-id-to-clipboard_placeHolderShimmer__BApxL"};